// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2OuwK","large":"styles_large__S5C6I"};